import React from "react";
import "@frameworks/web/stylesheets/components/generic/SuccessLinkPop.scss";
import DeviceContext from "./customHooks/indentifyDevice";
const FailureLinkPopUp = (props) => {
    var _a;
    const device = DeviceContext();
    return (React.createElement("div", { className: "Success-pop-link" },
        device && (device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement("div", { className: "spl-head bg_aqua_white flexJustifySpaceBetween" },
            React.createElement("div", { className: "DMSansBold_20_700 txt-midnight-blue" }, props.Title),
            (props === null || props === void 0 ? void 0 : props.crossBtn) && (React.createElement("div", { onClick: () => {
                    props.closeDropdown(false);
                } },
                React.createElement("i", { className: "edel-icon-cross-bold-small txt-black-magic hand_cursor" }))))),
        React.createElement("div", { className: "spl-body taCenter d-flex flex-column " },
            React.createElement("i", { className: "edel-icon-failure-popup icon" }, Array(7)
                .fill("")
                .map((i, idx) => (React.createElement("span", { key: idx, className: `path${idx + 1}` })))), (_a = props === null || props === void 0 ? void 0 : props.messageReactNode) !== null && _a !== void 0 ? _a : React.createElement(React.Fragment, null),
            (props === null || props === void 0 ? void 0 : props.goBackBtn) && (React.createElement("div", { onClick: () => {
                    props.closeDropdown(false);
                }, className: "DMSan_14_500 txt-midnight-blue icon-block flexCenter gap-5-custom hand_cursor" },
                React.createElement("i", { className: "edel-icon-left-shortArrow font-twelve" }),
                "Go Back")))));
};
export default FailureLinkPopUp;
